import { valueOrNA } from "./valueOrNA";

const getConfidence = (
  element: { confidence?: number | null } = {},
): string | number => {
  return valueOrNA(element?.confidence);
};

export default getConfidence;
